import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks';
import { Grid, LinearProgress, Typography } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material';
import {
  IQuickStartObject,
  IQuickStartCardObject
} from '../../../../types/landing-api-response.model';
import ToggleButtonGroupWithIcon from '../../section-1/toggle-button-group';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import Storage from 'src/utils/storage/storage';
import { getQuickStartUserCategoryData } from '../../../../store/landing-slice';
import CustomTabs from 'src/components/tabs/custom-tabs';

export default function UserCategory({
  categoryData
}: {
  categoryData: IQuickStartObject[];
}) {
  const [selectedSubTab, setSelectedSubTab] = useState(categoryData[0].name);

  const [cardsData, setCardsData] = useState(
    () => categoryData.filter((ele) => ele.name === categoryData[0].name)[0]
  );

  //   preparing sub tab data
  const subTabData = categoryData.map((ele) => ({
    label: ele.alias,
    value: ele.name,
    icon: ele.icon
  }));

  //   handler for toggling tabs
  const handleToggleChange = (event, newValue) => {
    setSelectedSubTab(newValue);
    // updating the cards data as per active tab
    const newActiveTabCardsData = categoryData.filter(
      (ele) => ele.name === newValue
    )[0];
    setCardsData(newActiveTabCardsData);
  };

  return (
    <div className='user-category-content-div-parent'>
      <div style={{ margin: '10px 0px' }}>
        <Typography className='quick-start-desc'>
          Reports are categorised based on the key performance indicators.
        </Typography>
      </div>

      <div className='user-profile-content-div'>
        <div className='tabs-container-div'>
          {CustomTabs({
            selectedTab: selectedSubTab,
            tabData: subTabData,
            handleToggleChange
          })}
        </div>

        <div className='cards-container'>
          <Grid container spacing={1}>
            {cardsData.data.map((ele: IQuickStartCardObject) => (
              <Grid item xs={6}>
                <div className='custom-card'>
                  <Link to={ele.page_route_url as string}>
                    <div className='page-details'>
                      <Typography className='page-details-text'>
                        {ele.page_prefix} {ele.page_alias}
                      </Typography>
                      <div className='page-details-icon'>
                        <KeyboardArrowRightIcon
                          sx={{ color: '#0000a0', fontSize: '18px' }}
                        />
                      </div>
                    </div>
                  </Link>
                  {ele.page_description &&
                    <Typography className='quick-start-desc' mt={1}>
                      {ele.page_description}<br /> {'if you want to know more about '}
                    </Typography>
                  }
                  {!ele.page_description && ele.questions &&
                    <Typography className='quick-start-desc' mt={1}>
                      {'if you want to know more about '}
                    </Typography>
                  }
                  <Typography className='quick-start-desc'>
                    {/* list of questions with ordered list */}
                    <ol style={{ paddingLeft: '20px' }}>
                      {ele.questions.map((ele, index) => (
                        <li value={index + 1}>{ele}</li>
                      ))}
                    </ol>
                  </Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
}
